import axios from "axios";

const getDefaultState = () => {
  return {
    allTaskTypes: [],
    allTaskTypesLoading: false,
    fieldtrackerToken: null,
    fieldTrackerService: {},
    fieldTrackerServiceLoading: false,
  };
};

const state = getDefaultState();

const getters = {
  getAllTaskTypes(state) {
    return state.allTaskTypes;
  },
  getAllTaskTypesLoading(state) {
    return state.allTaskTypesLoading;
  },
  getFieldtrackerToken(state) {
    return state.fieldtrackerToken;
  },
  getFieldTrackerService(state) {
    return state.fieldTrackerService;
  },
  getFieldTrackerServiceLoading(state) {
    return state.fieldTrackerServiceLoading;
  }
};

const actions = {
  async fetchTaskTypes({ rootGetters, commit }, payload) {
    return new Promise((resolve, reject) => {
      commit("setAllTaskTypesLoading", true);

      return new Promise((resolve, reject) => {
        if (state.fieldtrackerToken) {
          resolve(state.fieldtrackerToken);
        } else {
          fetch(rootGetters.getBackendUrl+'/fieldtracker/token').then(response => {
            return response.json();
          }).then(data => {
            // state.fieldtrackerToken = data.token;
            commit('setFieldtrackerToken', data.token);
            resolve(data.token);
          }).catch(err => {
            reject(err);
          });
        }
      }).then(token => {
        resolve(token);
      })
    }).then(fieldtracker_token => {
      axios
        .get(rootGetters.getFieldTrackerUrl+"/task_types", { headers: {
          Authorization: `Bearer ${fieldtracker_token}`
        }})
        .then((response) => {
          commit("setAllTaskTypes", response.data);
          commit("setAllTaskTypesLoading", false);
        })
        .catch(err => {
          console.error(err);

        })
        .finally(()=>{ commit("setAllTaskTypesLoading", false) });
    })
  },
  async fetchFieldTrackerService({ rootGetters, commit }, payload) {
    return new Promise((resolve, reject) => {
      commit("setFieldTrackerServiceLoading", true);

      return new Promise((resolve, reject) => {
        if (state.fieldtrackerToken) {
          resolve(state.fieldtrackerToken);
        } else {
          fetch(rootGetters.getBackendUrl+'/fieldtracker/token').then(response => {
            return response.json();
          }).then(data => {
            commit('setFieldtrackerToken', data.token);
            resolve(data.token);
          }).catch(err => {
            reject(err);
          });
        }
      }).then(token => {
        resolve(token);
      })
    }).then(fieldtracker_token => {
      axios
        .get(rootGetters.getFieldTrackerUrl+"/service_requests/"+payload.fieldtracker_reference, { headers: {
          Authorization: `Bearer ${fieldtracker_token}`
        }})
        .then((response) => {
          commit("setFieldTrackerService", response.data);
          commit("setFieldTrackerServiceLoading", false);
        })
        .catch(err => {
          console.error(err);
        })
        .finally(()=>{ commit("setFieldTrackerServiceLoading", false) });
    })
  }
}

const mutations = {
  setAllTaskTypes(state, payload) {
    state.allTaskTypes = payload;
  },
  setAllTaskTypesLoading(state, payload) {
    state.allTaskTypesLoading = payload;
  },
  setFieldtrackerToken(state, payload) {
    state.fieldtrackerToken = payload;
  },
  setFieldTrackerService(state, payload) {
    state.fieldTrackerService = payload;
  },
  setFieldTrackerServiceLoading(state, payload) {
    state.fieldTrackerServiceLoading = payload;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
